export default {
  toasts: {
    auth_token_invalid: "Jeton d'authentification invalide",
    host_access_refused:
      'Cette adresse appartient à un partenaire dont votre compte ne fait pas partie. Connectez-vous à votre propre adresse.',
  },
};
